import React, { forwardRef, useContext } from 'react'

import { mergeRefs } from 'utils/ref_utils'

import { ArrowContext, PopperContext } from './context'

interface PopperArrowProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  children: React.ReactNode | ((props: { side: 'top' | 'bottom' | 'left' | 'right' }) => React.ReactNode);
}

export const PopperArrow = forwardRef<HTMLDivElement, PopperArrowProps>(
  ({ children, ...props }, forwardedRef) => {
    const { setArrow } = useContext(PopperContext)
    const { side, x, y } = useContext(ArrowContext)

    function getOffsets () {
      switch (side) {
        case 'top':
          return {
            left: x,
            top: '100%',
          }
        case 'bottom':
          return {
            left: x,
            bottom: '100%',
          }
        case 'left':
          return {
            left: '100%',
            top: y,
          }
        case 'right':
          return {
            right: '100%',
            top: y,
          }
      }
    }

    function renderChildren () {
      if (typeof children === 'function') {
        return children({
          side,
        })
      }

      return children
    }

    return (
      <span
        {...props}
        ref={mergeRefs(setArrow, forwardedRef)}
        style={{
          ...props.style,
          position: 'absolute',
          ...getOffsets(),
        }}
      >
        {renderChildren()}
      </span>
    )
  }
)

PopperArrow.displayName = 'Popper.Arrow'
